module.exports = __webpack_public_path__ + "static/media/nextChevron.728d81fc.svg";